module.exports = __webpack_public_path__ + "static/media/remote5.c9f859d7.webp";